import React from "react";

import { WaitListDialogForm } from "../../components/buttons";
import { StakingDialogView } from "../../pages/mechanics/marketing/staking/rules/view";
import { StakingDepositDialog } from "../../components/buttons/mechanics/staking/deposit-complex/dialog";
import { StakesDialogView } from "../../pages/mechanics/marketing/staking/deposit/view";
import { DepositRewardDialog } from "../../components/dialogs/reward-dialog";
import { AmountDialog } from "../../components/buttons/hierarchy/template/purchase/dialog";

export enum MarketDialogKeys {
  WAITLIST_JOIN = "waitlistJoin",

  STAKING_RULE_VIEW = "stakingRuleView",
  STAKING_DEPOSIT_VIEW = "stakingDepositView",
  STAKING_DEPOSIT = "stakingDeposit",
  STAKING_REWARD = "stakingReward",

  AMOUNT = "amount",
}

export const marketGlobalDialogComponentsSchema = {
  [MarketDialogKeys.WAITLIST_JOIN]: WaitListDialogForm,

  [MarketDialogKeys.STAKING_RULE_VIEW]: StakingDialogView,
  [MarketDialogKeys.STAKING_DEPOSIT_VIEW]: StakesDialogView,
  [MarketDialogKeys.STAKING_DEPOSIT]: StakingDepositDialog,
  [MarketDialogKeys.STAKING_REWARD]: DepositRewardDialog,

  [MarketDialogKeys.AMOUNT]: AmountDialog,
} as const satisfies Record<MarketDialogKeys, React.ComponentType<any>>;
